import useGetCititesHook from "activity/sub_modules/areas/hooks/useGetCititesHook.hook";
import React from "react";
import Select from "react-select";
import useGetAreasHook from "../hooks/useGetAreas.hook";
import { activityPriorityApi as api } from "../api/ActivityPriority.api";
import { IDMCActivity } from "commonFnBcode/types/dmc.types";

function ActivityAreaUpdate({ activity }: { activity: IDMCActivity }) {
  const { area, setArea, data, isFetching } = useGetAreasHook();
  const [updateActivityArea, { isLoading }] = api.useUpdateAreaMutation();

  if (isLoading) return <h5>Loading...</h5>;
  return (
    <Select
      className="w-25"
      onInputChange={(val) => setArea(val)}
      defaultValue={{
        label: activity?.area?.name || "Not Assigned",
        value: activity?.area?.id || 0,
      }}
      onChange={(val: any) => {
        updateActivityArea({ activityId: activity.id, areaId: val.value });
      }}
      inputValue={area}
      placeholder="Search Areas"
      options={data}
    />
  );
}

export default ActivityAreaUpdate;
